<template>
  <div id="newsList">
    <ul>
      <li v-for="(item, i) in dataList" :key="i" @click="$router.push({path: '/newsDetail', query: {id: item.id}})">
        <img :src="item.img" alt="">
        <div>
          <p>{{item.title}}</p>
          <p>{{item.date}}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import newsData from '../../static/newsData'
  export default {
    name: 'newsList',
    data() {
      return {
        newsData
      }
    },
    props: ['tag'],
    components: {},
    computed: {
      dataList(){
        return this.tag === 0 ? this.newsData.footballNews : this.newsData.basketballNews
      }
    },
    created() {

    },
    methods: {

    }
  }
</script>

<style scoped lang="less">
  #newsList {
    padding: 50px 150px;
    ul{
      li{
        display: flex;
        flex-direction: row;
        cursor: pointer;
        &:not(:first-of-type){
          margin-top: 20px;
        }
        img{
          width: 150px;
          margin-right: 30px;
        }
        >div{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          p{
            &:nth-of-type(1){
              font-size: 20px;
              font-weight: bold;
              &:hover{
                color: #DE3637;
              }
            }
            &:nth-of-type(2){
              font-size: 16px;
              color: #999;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/newsList.vue